import Icon from '../components/Icon.vue'

Icon.register({
  'user-md': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 256C294.7 256 352 198.7 352 128S294.7 0 224 0 96 57.3 96 128 153.3 256 224 256zM104 424C104 437.3 114.7 448 128 448S152 437.3 152 424 141.3 400 128 400 104 410.7 104 424zM320 288.6V337.6C356.5 345 384 377.4 384 416V457.7C384 465.3 378.6 471.9 371.1 473.4L338.9 479.8C334.6 480.7 330.4 477.9 329.5 473.5L326.4 457.8C325.5 453.5 328.3 449.2 332.7 448.4L352 444.5V416C352 353.2 256 350.9 256 417.9V444.6L275.3 448.5C279.6 449.4 282.4 453.6 281.6 457.9L278.5 473.6C277.6 477.9 273.4 480.7 269.1 479.9L237.9 475.7C230 474.6 224.1 467.9 224.1 459.8V416C224.1 377.4 251.6 345.1 288.1 337.6V292.4C285.9 293.1 283.7 293.5 281.5 294.3 263.5 300.6 244.2 304.1 224.1 304.1S184.7 300.6 166.7 294.3C159.3 291.7 151.8 290.1 144.1 289.1V370.7C167.2 377.6 184.1 398.8 184.1 424.1 184.1 455 159 480.1 128.1 480.1S72.1 455 72.1 424.1C72.1 398.8 89 377.6 112.1 370.7V290.3C48.5 301 0 355.8 0 422.4V467.2C0 491.9 20.1 512 44.8 512H403.2C427.9 512 448 491.9 448 467.2V422.4C448 350.4 391.2 292.1 320 288.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-md.js
// module id = HQVI
// module chunks = 144